<template>
    <div class="mt-70">
    <app-header></app-header>
		<v-container fluid grid-list-lg pa-5 mt-2>
            <v-layout row wrap justify-center align-center fill-height mb-0>
                <v-flex lg12 sm12 xs12 md10 class="text-xs-center">
                    <!-- <v-card flat class="mx-5"> -->
                                <div class="font-24">FAQ</div>
                    <!-- </v-card> -->
                </v-flex>
                <v-flex xs12 sm12 md10 mt-3>
                    <v-layout wrap>
                         <v-flex xs12 sm6 md12>
                                <v-card flat class="px-3 py-3">
                                   <v-expansion-panel focusable>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq1')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt1')">
                                                
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq2')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt2')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq3')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt3')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq4')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt4')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq5')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt5')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq6')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt6')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    <v-expansion-panel-content
                                    >
                                        <template v-slot:header>
                                        <div>{{$t('faq.faq7')}}</div>
                                        </template>
                                        <v-card>
                                        <v-card-text>
                                            <span v-html="$t('faq.faqTxt7')">                                               
                                            </span>
                                        </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                    </v-expansion-panel>                                                     
                                </v-card>
                            </v-flex>
                    </v-layout>
                </v-flex> 
                    </v-layout>     
		</v-container>

    </div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                
               
                
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {

        },
    }
</script>


// WEBPACK FOOTER //
// FrequentlyAskedQuestions.vue?255a9496